<template>
  <figure class="responsive-image">
    <DrupalImage v-if="image?.image?.entity?.uri" :uri="image?.image?.entity?.uri || ''" :alt="altText"
      :alt-fallback="altFallback" :sizes="sizes" :image-styles="imageStyles" />
    <figcaption v-if="image.text" class="image__caption" v-html="useSanitizeHtml(image.text)" />
  </figure>
</template>

<script lang="ts" setup>
import { type MediaImageFragment } from '#graphql-operations'

interface ImageStyle {
  name: string
  width: number
}

export interface Props {
  image: MediaImageFragment
  altFallback?: string
  sizes?: string
  imageStyles?: ImageStyle[]
}

const props = withDefaults(defineProps<Props>(), {
  altFallback: '',
  sizes: '100vw',
  imageStyles: () => {
    return [
      { name: 'default_xs', width: 320 },
      { name: 'default_s', width: 640 },
      { name: 'default_m', width: 960 },
      { name: 'default_l', width: 1280 },
      { name: 'default_xl', width: 1440 },
      { name: 'default_xxl', width: 1920 },
      { name: 'default_xxxl', width: 2560 }
    ]
  }
})

const altText = computed(() => {
  if (props.image.image?.alt) {
    return props.image.image?.alt
  }
  return props.altFallback;
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.responsive-image {
  &__caption {
    @include tools.typo-small;

    p {
      @include tools.typo-small;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
